<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<script>

import AxiosSelect from '@components/base/inputs/AxiosSelect'

export default {
  name: 'AppointmentDates',
  extends: AxiosSelect,
  computed: {
    getAxiosUrl () {
      return this.apiService.appointmentDate.staticUtilities
    }
  }
}
</script>
